/* Swaps the try-buy app's own "Try it on" disclaimer copy for our own
   wording ("For best results, use a well-lit photo. Your image is
   processed in this browser session only and never stored.") -- on request
   ("can we change the grey copy below the generate button"). The
   disclaimer (<p class="tryon-disclaimer">) is injected by the app
   itself, not this theme, so there's no Liquid setting for it -- this
   is the only way to change its wording from our side.

   The app re-renders .tryon-modal-content each time the modal opens
   (confirmed: it's not a persistent DOM node), so a one-off query on
   page load would miss it. A MutationObserver watching the whole body
   catches every re-render, checks any added node for a
   .tryon-disclaimer (or a .tryon-disclaimer nested inside it), and
   overwrites the text immediately -- before the user ever sees the
   app's original copy flash on screen. */
(function () {
  var NEW_COPY = 'For best results, use a well-lit photo. Your image is processed in this browser session only and never stored.';

  function applyCopy(el) {
    if (el.textContent !== NEW_COPY) {
      el.textContent = NEW_COPY;
    }
  }

  function scan(root) {
    if (!(root instanceof Element)) return;
    if (root.matches && root.matches('.tryon-disclaimer')) {
      applyCopy(root);
    }
    var nested = root.querySelectorAll ? root.querySelectorAll('.tryon-disclaimer') : [];
    nested.forEach(applyCopy);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(scan);
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.querySelectorAll('.tryon-disclaimer').forEach(applyCopy);
})();
